import { SvgIcon } from "./SvgIcon";
import { v4 as uuidv4 } from "uuid";

function IconComponent(props: any) {
  const uid = uuidv4();

  return (
    <SvgIcon {...props} viewBox="0 0 16 16">
      <g clipPath={`url(#clip${uid})`}>
        <path d="M8.00156 12C8.30156 12 8.50156 11.9 8.70156 11.7L14.4016 6L13.0016 4.6L9.00156 8.6V0H7.00156V8.6L3.00156 4.6L1.60156 6L7.30156 11.7C7.50156 11.9 7.70156 12 8.00156 12Z" />
        <path d="M14 14H2V11H0V15C0 15.6 0.4 16 1 16H15C15.6 16 16 15.6 16 15V11H14V14Z" />
      </g>
      <defs>
        <clipPath id={`clip${uid}`}>
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export default IconComponent;
